import axios from "axios";

export const deleteProfile = async (id?: string) => {
    return await axios.delete(`api/profiles/${id}`);
}